module.exports = __webpack_public_path__ + "static/media/arrow-down.d41d8cd9.svg";